import axios from 'axios'

class TelehealthService {
  constructor() {
    this.baseUrl = '/api/v1/'
  }

  bookAppointment(data) {
    return axios.post(`${this.baseUrl}patients/book_appointment/`, data)
  }

  rescheduleMeeting(data) {
    return axios
      .post(`${this.baseUrl}patients/update_appointment/`, data)
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response.status === 400 && error.response.data) {
          return error.response.data
        }
      })
  }
}

export const telehealthService = new TelehealthService()
